import { AuthContext } from 'app/features/auth/AuthContext';
import type { IAuthContextType } from 'app/features/auth/AuthContext';
import { useContext } from 'react';

export const useAuth = (): IAuthContextType => {
	return useContext(AuthContext);
};
